"use client";

export default function Step1EventType({ formData, updateFormData, onNext }) {
  const handleSelectEventType = (type) => {
    updateFormData({ eventType: type });
    onNext();
  };

  return (
    <div>
      <div className="text-xs uppercase text-gray-500 font-medium mb-4">
        STEP 1
      </div>
      <h2 className="text-2xl font-bold mb-1">
        what kind of event are you hosting?
      </h2>
      <p className="text-gray-500 mb-6">Let's kick things off</p>

      <div className="grid grid-cols-3 gap-4">
        <button
          onClick={() => handleSelectEventType("Personal Events")}
          className={`p-4 border rounded-lg text-left hover:border-[#7B189F] transition-colors ${
            formData.eventType === "Personal Events"
              ? "border-[#7B189F]"
              : "border-gray-200"
          }`}
        >
          <div className="flex flex-col items-center">
            <img
              src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Frame-owEy70Ruhob0znx75OJ8zVU8P5jF8m.png"
              alt="Personal Events"
              className="w-16 h-16 mb-4"
            />
            <div className="text-center">
              <h3 className="text-base font-semibold">Personal Events</h3>
              <p className="text-xs text-gray-500 mt-1">
                Celebrating moments close to your heart
              </p>
            </div>
          </div>
        </button>

        <button
          onClick={() => handleSelectEventType("Community Events")}
          className={`p-4 border rounded-lg text-left hover:border-[#7B189F] transition-colors ${
            formData.eventType === "Community Events"
              ? "border-[#7B189F]"
              : "border-gray-200"
          }`}
        >
          <div className="flex flex-col items-center">
            <img
              src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Frame%20%281%29-s3s3mPjiItKiBKuvjfpJAA3Z8OCE7o.png"
              alt="Community Events"
              className="w-16 h-16 mb-4"
            />
            <div className="text-center">
              <h3 className="text-base font-semibold">Community Events</h3>
              <p className="text-xs text-gray-500 mt-1">
                Bringing people together for shared experiences.
              </p>
            </div>
          </div>
        </button>

        <button
          onClick={() => handleSelectEventType("Commercial Event")}
          className={`p-4 border rounded-lg text-left hover:border-[#7B189F] transition-colors ${
            formData.eventType === "Commercial Event"
              ? "border-[#7B189F]"
              : "border-gray-200"
          }`}
        >
          <div className="flex flex-col items-center">
            <img
              src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Frame%20%282%29-T9zOMYj8u2EOOc3WDNti8Cey1kLVpG.png"
              alt="Commercial Event"
              className="w-16 h-16 mb-4"
            />
            <div className="text-center">
              <h3 className="text-base font-semibold">Commercial Event</h3>
              <p className="text-xs text-gray-500 mt-1">
                Connecting businesses and audiences for impact.
              </p>
            </div>
          </div>
        </button>
      </div>
    </div>
  );
}
